<template>
    <div>
        <ModalHeader title="신청서 작성" />
        <div style="flex:1; overflow:auto;">
            <div style="padding:0px 20px;">
                <div style="height:20px; "></div>
                <div class="form-group">
                    <label class="required">이름</label>
                    <input
                        type="text"
                        v-model="formData.name"
                        ref="member_name"
                        placeholder="이름을 입력해주세요"
                        enterkeyhint="next"
                        @keyup="next($event, 'phone_el')"
                    >
                </div>

                <div class="form-group">
                    <label class="required">휴대폰번호</label>
                    <div class="phone-input-group" style="display:flex;">
                        <input
                            type="text"
                            v-model="formData.phone"
                            placeholder="휴대폰번호를 입력해주세요"
                            style="flex:1;"
                            ref="phone_el"
                            maxlength="13"
                            inputmode="numeric"
                            :readonly="isVerified"
                        >
                        <ProgressButton
                            :buttonText="isShowVerificationInput ? '재전송' : '인증번호전송'"
                            :showProgress="isSendingCode"
                            @click="sendVerificationCode"
                            style="margin-top:0px; width:120px; margin-left:5px;"
                        />
                    </div>
                </div>

                <div class="form-group" v-if="isShowVerificationInput">
                    <label class="required">인증번호</label>
                    <div class="verification-input-group">
                        <input
                            type="text"
                            v-model="formData.authNumber"
                            placeholder="인증번호를 입력해주세요"
                            :readonly="isVerified"
                            inputmode="numeric"
                        >
                        <ProgressButton
                            :buttonText="isVerified ? '인증됨' : '확인'"
                            :showProgress="isVerifying"
                            @click="verifyCode"
                            :style="{backgroundColor : isVerified ? 'gray' : null}"
                        />
                    </div>
                </div>

                <div class="form-group">
                    <label class="required">주민번호</label>
                    <input
                        type="text"
                        v-model="formData.jumin"
                        maxlength="14"
                        placeholder="주민번호를 입력해주세요(숫자만 입력)"
                        @blur="checkManWoman"
                        ref="jumin_el"
                        inputmode="numeric"
                    >
                </div>

                <div class="form-group">
                    <label class="required">주소</label>
                    <input
                        type="text"
                        v-model="formData.zip_code"
                        placeholder="우편번호"
                        style="width:100px;vertical-align: top;"
                        enterkeyhint="next"
                        @keyup="next($event, 'address1')"
                    >
                    <ProgressButton button-text="검색" @click="showDaumAddress" style="width:60px; display:inline-block; margin-top:0px; margin-left:5px;vertical-align: top;"/>
                    <input
                        type="text"
                        v-model="formData.address1"
                        ref="address1"
                        placeholder="주소"
                        style="margin-top:5px;"
                        enterkeyhint="next"
                        @keyup="next($event, 'address2')"
                    >
                    <input
                        type="text"
                        v-model="formData.address2"
                        ref="address2"
                        placeholder="나머지 주소"
                        style="margin-top:5px;"
                        enterkeyhint="next"
                    >
                </div>

                <div class="form-group">
                    <label class="required">성별</label>
                    <div style="display:flex;" ref="gender_wrap">
                        <div style="display:flex; align-items: center; padding:5px 0px;" @click="setGender('남')">
                            <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                <div v-if="formData.gender === '남'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                            </div>
                            <div style="margin-left:5px; color:#210F03;font-weight:500;">남자</div>
                        </div>
                        <div style="display:flex; align-items: center; padding:5px 0px; margin-left:10px;" @click="setGender('여')">
                            <div style="position:relative; border-radius:50%; width:20px; height:20px; border:1px solid #BBBBBB;">
                                <div v-if="formData.gender === '여'" style="width:14px; height:14px; border-radius:50%; background-color: #2196F3; position:absolute; left:2px; top:2px;"></div>
                            </div>
                            <div style="margin-left:5px; color:#210F03;font-weight:500;">여자</div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="required">키</label>
                    <input
                        type="text"
                        v-model="formData.height"
                        placeholder="숫자만 입력(cm)"
                        ref="height_el"
                        style="width:130px;"
                        maxlength="3"
                        inputmode="numeric"
                        enterkeyhint="next"
                        @keyup="next($event, 'weight')"
                    >
                </div>

                <div class="form-group">
                    <label class="required">몸무게</label>
                    <input
                        type="text"
                        v-model="formData.weight"
                        ref="weight_el"
                        placeholder="숫자만 입력(kg)"
                        style="width:130px;"
                        maxlength="3"
                        inputmode="numeric"
                        enterkeyhint="next"
                    >
                </div>

                <div class="form-group">
                    <label class="required">지원경로</label>
                    <select v-model="formData.route" ref="route_el">
                        <option value="인력소개">인력소개</option>
                        <option value="외주업체">외주업체</option>
                        <option value="기타">기타</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="required">은행</label>
                    <select v-model="formData.bank_name" ref="bank_name_el">
                        <option v-for="each, i in BANKS" :key="i" :value="each.name">{{each.name}}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label class="required">계좌명</label>
                    <input
                        type="text"
                        v-model="formData.bank_account_name"
                        ref="bank_account_name_el"
                        placeholder=""
                        enterkeyhint="next"
                        @keyup="next($event, 'bank_account_el')"
                    >
                </div>

                <div class="form-group">
                    <label class="required">계좌번호</label>
                    <input
                        type="text"
                        v-model="formData.bank_account"
                        ref="bank_account_el"
                        placeholder="숫자만 입력"
                        inputmode="numeric"
                        enterkeyhint="next"
                        @keyup="next($event, 'recommender')"
                    >
                </div>

                <div class="form-group">
                    <label>소개자 및 지인</label>
                    <input
                        type="text"
                        v-model="formData.recommender"
                        ref="recommender"
                        placeholder="소개자명을 입력해주세요.(선택사항)"
                        enterkeyhint="next"
                        @keyup="next($event, 'remark')"
                    >
                </div>

                <div class="form-group">
                    <label>특이사항</label>
                    <textarea v-model="formData.remark" ref="remark" placeholder="신체 질병 및 질환 등 특이사항(선택사항)" style="height:85px; line-height:18px;"></textarea>

                    <!--<input-->
                            <!--type="text"-->
                            <!--v-model="formData.remark"-->
                            <!--placeholder="신체 질병 및 질환 등 특이사항(선택사항)"-->
                    <!--&gt;-->
                </div>

                <div style="height:50px;"></div>
            </div>
        </div>
        <div style="padding:10px; border-top:1px solid #ddd;">
            <ProgressButton buttonText="신청" :showProgress="isSubmitting" @click="submit" style="margin-top:0px;"/>
        </div>
    </div>
</template>

<script>
    import ModalHeader from "../common/ModalHeader";
    import ProgressButton from "../common/ProgressButton";
    import {BANKS, FORM_MODE} from "../../Constants";
    import ResponseCode from "../../ResponseCode";
    export default {
        name: "Survey",
        components: {ProgressButton, ModalHeader},
        props : {
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                formData : {
                    name : '',
                    jumin : '',
                    phone : '',
                    authNumber : '',
                    zip_code : '',
                    address1 : '',
                    address2 : '',
                    route : '',
                    gender : '',
                    height: '',
                    weight : '',
                    remark : '',
                    recommender : '',
                    bank_name : '',
                    bank_account_name : '',
                    bank_account : '',
                },
                isVerified : false,
                isSendingCode : false,
                isVerifying : false,
                isShowVerificationInput : false,
                isSubmitting : false,
                BANKS : BANKS
            }
        },
        methods : {
            next(e, next_target_key){
                if(e.keyCode === 13){
                    this.$refs[next_target_key].focus();
                }
            },
            checkManWoman(){
                // if(this.formData.jumin.length === 14){
                //     const first_number = this.formData.jumin.substr(7, 1);
                //     if(first_number === '1' || first_number === '3'){
                //         this.formData.gender = '남';
                //     }else {
                //         this.formData.gender = '여';
                //     }
                // }
            },
            async submit(){
                if(this.formData.name === ''){
                    this.$GlobalStore.showAlert('이름을 입력해주세요.');
                    this.$refs.member_name.focus();
                    return;
                }

                if(this.formData.jumin === ''){
                    this.$GlobalStore.showAlert('주민번호를 입력해주세요.');
                    this.$refs.jumin_el.focus();
                    return;
                }

                if(this.formData.jumin.length !== 14){
                    this.$GlobalStore.showAlert('주민번호를 모두 입력해주세요.');
                    this.$refs.jumin_el.focus();
                    return;
                }

                const jumin_format = /\d{6}-\d{7}/gi;
                if(!jumin_format.test(this.formData.jumin)){
                    this.$GlobalStore.showAlert('주민번호 형식이 맞지 않습니다.');
                    this.$refs.jumin_el.focus();
                    return;
                }

                if(this.formData.address1 === ''){
                    this.$GlobalStore.showAlert('주소를 검색해주세요.');
                    this.$refs.address1.focus();
                    return;
                }

                if(this.formData.gender === ''){
                    this.$GlobalStore.showAlert('성별을 선택해주세요.');
                    this.$refs.gender_wrap.scrollIntoView({block : 'center'});
                    return;
                }

                if(this.formData.height === ''){
                    this.$GlobalStore.showAlert('키를 입력해주세요.');
                    this.$refs.height_el.focus();
                    return;
                }

                if(this.formData.weight === ''){
                    this.$GlobalStore.showAlert('몸무게를 입력해주세요.');
                    this.$refs.weight_el.focus();
                    return;
                }

                if(this.formData.route === ''){
                    this.$GlobalStore.showAlert('지원경로를 선택해주세요.');
                    this.$refs.route_el.scrollIntoView({block : 'center'});
                    return;
                }

                if(this.formData.bank_name === ''){
                    this.$GlobalStore.showAlert('은행을 선택해주세요.');
                    this.$refs.bank_name_el.scrollIntoView({block : 'center'});
                    return;
                }

                if(this.formData.bank_account_name === ''){
                    this.$GlobalStore.showAlert('계좌명을 입력해주세요.');
                    this.$refs.bank_account_name_el.focus();
                    return;
                }

                if(this.formData.bank_account === ''){
                    this.$GlobalStore.showAlert('계좌번호를 입력해주세요.');
                    this.$refs.bank_account_el.focus();
                    return;
                }

                //회원가입 이름과 계좌명이 다를경우에만 동의서 작성하도록
                if(this.formData.bank_account_name !== this.formData.name){
                    if(!confirm("신청자명과 계좌명이 다르기 때문에 임금 수령 동의서를 작성해야합니다.\n계속 진행하시겠습니까?")){
                        return;
                    }
                    this.$GlobalStore.addModal('WagesAgreement', {
                        agreement_info : {
                            name : this.formData.bank_account_name,
                            bank_name : this.formData.bank_name,
                            bank_account : this.formData.bank_account
                        },
                        completeAction : async (base64_str) => {
                            await this.saveData(base64_str);
                        }
                    });
                } else {
                    await this.saveData('');
                }
            },
            async saveData(base64str){
                const parameters = {};
                parameters.mode = FORM_MODE.INSERT;
                parameters.agreement_image = base64str;
                Object.assign(parameters, this.formData);
                parameters.address = this.formData.address1 + (this.formData.address2 ? ' ' + this.formData.address2 : '');

                this.isSubmitting = true;
                const res = await this.$Axios.post('/api/survey/save', parameters);
                this.isSubmitting = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.closeLastModal();
                    this.completeAction();
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            showDaumAddress(){
                this.$GlobalStore.addModal('DaumAddress', {completeAction : (zip_code, address) => {
                        this.formData.zip_code = zip_code;
                        this.formData.address1 = address;
                        setTimeout(() => {
                            this.$refs.address2.focus();
                        }, 100)
                    }
                });
            },
            async verifyCode(){
                if(this.isVerified) return;

                const parameters = {};
                parameters.phone = this.formData.phone;
                parameters.authNumber = this.formData.authNumber;
                this.isVerifying = true;
                const res = await this.$Axios.post('/api/auth/check', parameters);
                this.isVerifying = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    // this.$GlobalStore.showToast('인증되었습니다.');
                    this.isVerified = true;
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async sendVerificationCode(){
                const parameters = {};
                parameters.phone = this.formData.phone;
                this.isSendingCode = true;
                const res = await this.$Axios.post('/api/auth/number', parameters);
                this.isSendingCode = false;
                if(res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.showAlert('인증번호가 전송되었습니다.');
                    this.isShowVerificationInput = true;
                } else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            setGender(gender){
                console.log(gender);
                this.formData.gender = gender;
            },
        },
        mounted(){
            this.$Util.setPhoneFormatter(this.$refs.phone_el);
            this.$Util.setJuminFormmater(this.$refs.jumin_el);
        },
        created(){
            this.submit = this.$Once(this.submit);
            this.verifyCode = this.$Once(this.verifyCode);
            this.saveData = this.$Once(this.saveData);
        }
    }
</script>

<style scoped>
    .login-form {
        max-width: 400px;
        margin: 0 auto;
    }

    .form-group {
        margin-bottom: 20px;
    }

    label {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
    }

    label.required{
        color:#ff4b00;
    }

    input {
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        height: 44px;
    }


    select {
        width: 100%;
        padding: 0px 6px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        height: 44px;
        background-color: white;
        color:black;
    }

    button {
        padding: 8px 16px;
        background-color: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        height: 44px;
    }

    button:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }

    textarea{
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
        height: 44px;
    }

</style>